export function commonInitMenu2(dropDown, wsMgr, numRows, x, y, ddWidth) {
  var backgrnd = wsMgr.GetBackgroundPanel();
  var extraHeight = 0;

  dropDown.AutoPosition(backgrnd, extraHeight, x, y, ddWidth, numRows);
}
